module.exports = __webpack_public_path__ + "img/system.bb99bd9d.svg";